/* template */
<template><div class="group-rules-wrap"><div class="rules-title">{{$t('common.groupRule')}}</div><mpx-image :class='("group-rule-image "+(imageStyle))' mode="heightFix" :src="(ruleImage)"></mpx-image></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m31053769"}'>
@import '../../lib/stylus/variable.styl'

.group-rules-wrap
  background #FCFDFE
  padding 39rpx
  .rules-title
    font-weight $fw-semi-bold
    font-size 30rpx
    color #333333
    line-height 28rpx
    margin-bottom 30rpx
  .group-rule-image
    width 510rpx
    height 120rpx
    background-size 100% 100%
    background-repeat no-repeat
    margin 0 auto
    &.en-US
      width 610rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { GlobalEnv } from '../../lib/webx'

const GroupImage = {
  'zh-CN': 'https://ut-static.udache.com/webx/fe-agility-wyc/Dkroxami3YjEDxV_6bI8d.png',
  'en-US': 'https://ut-static.udache.com/webx/fe-agility-wyc/bv_Z1NBA2S1wZ_pY1emeN.png',
  'zh-HK': 'https://ut-static.udache.com/webx/fe-agility-wyc/Dkroxami3YjEDxV_6bI8d.png',
}
createComponent({
  computed: {
    ruleImage() {
      return GroupImage[GlobalEnv.lang]
    },
    imageStyle() {
      return GlobalEnv.lang
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "group-rules31053769",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
